import React from 'react';
import { Link } from 'react-router-dom';

const appListStyles = {
  maxWidth: '800px',
  margin: '60px auto',
  padding: '20px',
};

const appCardStyles = {
  backgroundColor: 'white',
  borderRadius: '10px',
  padding: '20px',
  marginBottom: '20px',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  transition: 'transform 0.2s ease',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  ':hover': {
    transform: 'translateY(-2px)',
  }
};

const appLogoStyles = {
  width: '50px',
  height: '50px',
  borderRadius: '10px',
  marginRight: '20px',
}

const AppList = ({ apps }) => {
  return (
    <div style={appListStyles}>
      <h1 style={{ marginBottom: '30px', textAlign: 'center' }}>Our Apps</h1>
      <div style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' }}>
        {Object.entries(apps).map(([key, app]) => (
          <Link
            key={key}
            to={app.route}
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <div style={appCardStyles}>
              <img
                src={`${process.env.PUBLIC_URL}/${key}/logo.png`}
                alt={`${app.name} logo`}
                style={appLogoStyles}
              />
              <h3 style={{ margin: 0 }}>{app.name}</h3>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AppList;